import styled from "@emotion/styled";
import { Button, ButtonProps } from "react-bootstrap";
import { IStyledComponentProps } from "../../theme/theme.types";

const GENERIC_BUTTON_STYLES = `
  border-radius: 0;
  font-family: Open Sans Semi Bold;
  padding: 12px 20px;
  text-align: center;

  &.block {
    width: 100%;
  }

  &:hover {
    cursor: pointer;
  }
`;

const BlueSecondaryButton = styled(Button)<IStyledComponentProps & ButtonProps>`
  &.blue-secondary-button {
    ${GENERIC_BUTTON_STYLES}
    background-color: ${(props) =>
      props.theme.colors.essential.white}!important;
    color: ${(props) => props.theme.colors.brand.primary};
    border-color: ${(props) => props.theme.colors.brand.primary};

    &:hover {
      color: ${(props) => props.theme.colors.brand.secondary}!important;
      border-color: ${(props) => props.theme.colors.brand.secondary}!important;
    }
  }
`;

const RedPrimaryButton = styled(Button)<IStyledComponentProps & ButtonProps>`
  &.red-primary-button {
    ${GENERIC_BUTTON_STYLES}
    background-color: #fae7e7 !important;
    color: ${(props) => props.theme.colors.alerts.primary};
    border-color: ${(props) => props.theme.colors.alerts.primary};

    &:hover {
      background-color: ${(props) =>
        props.theme.colors.alerts.primary} !important;
      color: ${(props) => props.theme.colors.essential.white} !important;
      border-color: ${(props) => props.theme.colors.alerts.primary} !important;
    }
  }
`;

export default {
  BlueSecondaryButton,
  RedPrimaryButton,
};
